import { Stack, Typography } from "@mui/material"
import React from "react"
import useTrans from "@/hooks/useTrans"
import Claim from "./claim"
import Convert from "./convert"

const View = () => {
  const trans = useTrans()

  return (
    <Stack
      className='p-4 sm:px-10 sm:py-6 border border-solid border-secondary rounded-lg bg-white h-full'
      gap={1}
      data-testid='staking-detail-my-rewards'
    >
      <Typography className='font-semibold sm:text-2xl'>{trans.staking.detail.my_staking_reward}</Typography>

      <Claim />

      <hr className='my-10 text-secondary' />

      <Convert />
    </Stack>
  )
}

export default View
